import { isServer } from 'src/shared/utils';

export enum envEnum {
  NEXT_PUBLIC_ENVIRONMENT = 'NEXT_PUBLIC_ENVIRONMENT',
  NODE_BACKEND_SERVER = 'NODE_BACKEND_SERVER',
  NEXT_IS_PROXY_ENABLED = 'NEXT_IS_PROXY_ENABLED',
}

export type TClientEnv = Partial<Record<envEnum, string>>;

export const getEnv = (env: envEnum): string => {
  const resp = isServer ? process.env[env] : window.process.env[env];

  if (resp) return resp;
  throw new Error(`Empty env: ${env}`);
};
